
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlGeneric as ObiOwnShipControlGenericElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-generic.js';
 
 
 

 
 export const ObiOwnShipControlGeneric = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-generic',
   elementClass: ObiOwnShipControlGenericElement,
   events: {
     
   }
  });
 
 